import React from 'react';
import { Layout, Link } from '@arco-design/web-react';
import { FooterProps } from '@arco-design/web-react/es/Layout/interface';
import cs from 'classnames';
import styles from './style/index.module.less';
import { useHistory } from 'react-router-dom';

function Footer(props: FooterProps = {}) {
  const { className, ...restProps } = props;
  const history = useHistory();

  const handleChangelog = () => {
    history.push('/change-log');
  };

  return (
    <Layout.Footer className={cs(styles.footer, className)} {...restProps}>
      ©{new Date().getFullYear()} Created by 速问团队{' '}
      <span style={{ margin: '0 5px' }}>-</span>
      <Link
        href="https://beian.miit.gov.cn/"
        target="_blank"
        rel="noopener noreferrer"
      >
        京ICP备2023015457号-2
      </Link>
      <span style={{ margin: '0 5px' }}>-</span>
      <Link onClick={handleChangelog}>更新日志</Link>
    </Layout.Footer>
  );
}

export default Footer;
